import {ToolExecuteParams, ToolResult} from 'common/src/modules/shared/copilot/copilot.types';
import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import {CLStore} from 'common/src/redux/store';
import {z} from 'zod';
import {BrandGuidelinesAgentToolName} from '../brandGuidelinesAgent.enums';

const inputSchema = z.object({
  personaId: z.number().describe('The ID of the persona to get details for'),
});

function getPersonaDetailsTool(store: CLStore) {
  async function execute({
    input: {personaId},
  }: ToolExecuteParams<typeof inputSchema>): Promise<ToolResult> {
    const brandPersonasData = store.getState().brandGuidelinesPage.brandPersonas.data;

    if (!brandPersonasData) {
      return toolResult(`No personas data available. The personas may not be loaded yet.`);
    }

    const persona = brandPersonasData.find((p) => p.id === personaId);

    if (!persona) {
      return toolResult(`Persona with ID ${personaId} not found.`);
    }

    // Remove avatarUrl and return JSON serialized persona
    const personaWithoutAvatar = {
      id: persona.id,
      name: persona.name,
      description: persona.description,
      keyInterests: persona.keyInterests,
      painPoints: persona.painPoints,
      resonatingMessages: persona.resonatingMessages,
      avoidances: persona.avoidances,
      minAge: persona.minAge,
      maxAge: persona.maxAge,
    };

    return toolResult(`${JSON.stringify(personaWithoutAvatar, null, 2)}`);
  }

  return tool({
    name: BrandGuidelinesAgentToolName.GetPersonaDetails,
    description: 'Get detailed information about a specific persona by its ID',
    displayName: 'Getting persona details',
    inputSchema,
    execute,
  });
}

export default getPersonaDetailsTool;
